import { useSWRConfig } from 'swr';
import { useParams } from 'react-router-dom';
import { postFetcher } from '@/api/fetchers';
import type { CreateExceptionalEvent } from '@/schemas/API/POST/employee/exceptional-event/request';

export default function useCreateExceptionalEvent() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const createExceptionalEvent = async (
    exceptionalEvent: CreateExceptionalEvent
  ) => {
    if (!employeeId) throw new Error('employeeId is undefined. Check URL.');

    await postFetcher(
      `/employees/${employeeId}/exceptional-events`,
      exceptionalEvent
    );

    await mutate(`/employees/${employeeId}/exceptional-events`);
  };

  return {
    createExceptionalEvent,
  };
}
